export const header = () => {


    let pageHeader = document.querySelector('.nav-wrapper');

    window.onscroll = function(e) {
        // print "false" if direction is down and "true" if up
        //console.log(this.oldScroll > this.scrollY);
        scroll_back_up = this.oldScroll > this.scrollY;

        if(scroll_back_up){
            pageHeader.classList.add('header-scrolled-back');
        }else{
            pageHeader.classList.remove('header-scrolled-back');
        }

        this.oldScroll = this.scrollY;

        if(this.scrollY < 350){
            //console.log('top of page, revert nav');
            pageHeader.classList.add('top-of-page');
        }

        if(this.scrollY > 350){
            pageHeader.classList.remove('top-of-page');
        }
    }


    
	//Hide the header as the users scrolls down, reveal it again if they scroll up
	//let pageHeader = document.querySelector('.nav-wrapper'),
	scrollBuffer = 0;//50; //Pixel buffer of movement before the header is hidden/revealed
	let lastScrollPosition 	= 0;




	document.addEventListener('scroll', (event) => {

		if(scrollY > scrollBuffer){
			if(window.scrollY > (lastScrollPosition + scrollBuffer)){
				//Scrolling down the page
				pageHeader.classList.add('header-scrolled');
                pageHeader.classList.remove('header-scrolled-back');
                //pageHeader.classList.remove('header-scrolled-back');
				
				lastScrollPosition = window.scrollY;
			}else if(window.scrollY < (lastScrollPosition - scrollBuffer)){
				//Scrolling back up
				//pageHeader.classList.add('header-scrolled-back');
				
				lastScrollPosition = window.scrollY;
			}
		}else{
			pageHeader.classList.remove('header-scrolled');
			
		}
		
  		
	});
    
	
}


header();